import { useRoutes } from "react-router-dom";
import ToolLayout from "./components/ToolLayout/ToolLayout";
import Permission from "./store/permissions";
// Auth
import SignInForm from "./Pages/Auth/SignIn";
import RegistrationForm from "./Pages/Auth/Registration";
import ForgotPasswordForm from "./Pages/Auth/ForgotPassword";
// Policies & Terms
import TermsFeedPage from "./Pages/PoliciesTermsToolPages/TermsFeedPage";
import FormPage from "./Pages/PoliciesTermsToolPages/FormPage";
import PoliciesPage from "./Pages/PoliciesTermsToolPages/PoliciesPage";

const AppRoutesDevelopment = () => {
    const routes = useRoutes([
        { path: "/", element: null },
        
        // Auth
        { path: "/log-in", element: <SignInForm /> },
        { path: "/registration", element: <RegistrationForm /> },
        { path: "/forgot-password", element: <ForgotPasswordForm /> },
        
        // Tool Layout - Primary route for all tools
        { path: "/tool/:id", element: <ToolLayout /> },

        // Backward compatible routes (will redirect to /tool/:id)
        { path: "/fancy-text", element: <ToolLayout /> },
        { path: "/social-media-mockup", element: (
            <Permission>
                <ToolLayout />
            </Permission>
        )},
        { path: "/policies-terms", element: <TermsFeedPage /> },
        { path: "/form/:id", element: <FormPage /> },
        { path: "/download/:id", element: <PoliciesPage /> },
        { path: "/google-ads-calculator", element: <ToolLayout /> },
        { path: "/voice-recorder-online", element: <ToolLayout /> },
        { path: "/calendar-share", element: <ToolLayout /> },
        { path: "/multi-url-opener", element: <ToolLayout /> },
        { path: "/email-validator", element: <ToolLayout /> },
        { path: "/invoice-generator", element: (
            <Permission>
                <ToolLayout />
            </Permission>
        )},
        { path: "/color-picker", element: <ToolLayout /> },
        { path: "/compress-image", element: <ToolLayout /> },
        { path: "/loan-amotization-calculator", element: <ToolLayout /> },
        { path: "/loan-calculator", element: <ToolLayout /> },
        { path: "/mortage-calculator", element: <ToolLayout /> },
        { path: "/num-to-words", element: <ToolLayout /> },
        { path: "/percentage-calculator", element: <ToolLayout /> },
        { path: "/qr-code-generator", element: <ToolLayout /> },
        { path: "/random-password-generator", element: <ToolLayout /> },
        { path: "/remove-duplicate", element: <ToolLayout /> },
        { path: "/split-pdf", element: <ToolLayout /> },
        { path: "/text-to-speach", element: <ToolLayout /> },
        { path: "/jpg-to-png", element: <ToolLayout /> },
        { path: "/png-to-jpg", element: <ToolLayout /> },
        { path: "/heic-to-jpg", element: <ToolLayout /> },
        { path: "/webp-to-jpg-converter", element: <ToolLayout /> },
        { path: "/word-to-jpg-converter", element: <ToolLayout /> },
        { path: "/jpeg-to-word-converter", element: <ToolLayout /> },
        { path: "/pdf-to-word-converter", element: <ToolLayout /> },
        { path: "/ppt-to-pdf-converter", element: <ToolLayout /> },
        { path: "/excel-to-pdf-converter", element: <ToolLayout /> },
        { path: "/pdf-to-jpg-converter", element: <ToolLayout /> },
        { path: "/jpg-to-pdf-converter", element: <ToolLayout /> },
        { path: "/pdf-merger", element: <ToolLayout /> },
        { path: "/word-to-jpeg-converter", element: <ToolLayout /> },
        { path: "/binary-to-decimal", element: <ToolLayout /> },
        { path: "/binary-to-hex", element: <ToolLayout /> },
        { path: "/binary-to-octal", element: <ToolLayout /> },
        { path: "/binary-to-string", element: <ToolLayout /> },
        { path: "/decimal-to-binary", element: <ToolLayout /> },
        { path: "/decimal-to-hex", element: <ToolLayout /> },
        { path: "/decimal-to-octal", element: <ToolLayout /> },
        { path: "/hex-to-binary", element: <ToolLayout /> },
        { path: "/hex-to-decimal", element: <ToolLayout /> },
        { path: "/hex-to-octal", element: <ToolLayout /> },
        { path: "/data-size-converter", element: <ToolLayout /> },
        { path: "/md5-hash", element: <ToolLayout /> },
        { path: "/octal-to-binary", element: <ToolLayout /> },
        { path: "/octal-to-decimal", element: <ToolLayout /> },
        { path: "/octal-to-hex", element: <ToolLayout /> },
        { path: "/rgb-to-hex", element: <ToolLayout /> },
        { path: "/string-to-binary", element: <ToolLayout /> },
        { path: "/sha1-hash", element: <ToolLayout /> },
        { path: "/sha256-hash", element: <ToolLayout /> },
        { path: "/sha512-hash", element: <ToolLayout /> },
        { path: "/word-count", element: <ToolLayout /> },
        { path: "/base-64-decode", element: <ToolLayout /> },
        { path: "/base-64-encode", element: <ToolLayout /> },
        { path: "/jpeg-to-bmp-converter", element: <ToolLayout /> },
        { path: "/campaign-url-builder", element: <ToolLayout /> },

    ]);

    return routes;
};

export default AppRoutesDevelopment;